export const toPascalCase = (str: string): string => {
  return str.replace(/\w+/g, (word) => {
    return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
  });
};

export const lineBreakLabels = (labels: string[], maxLength: number): string[] => {
  return labels.map((label) => {
    if (label.length > maxLength) {
      const words = label.split(' ');
      const numBreakPoints = Math.ceil(label.length / maxLength) - 1;
      const breakInterval = Math.ceil(words.length / (numBreakPoints + 1));

      for (let i = breakInterval - 1; i < words.length; i += breakInterval) {
        words[i] += '<br>';
      }

      return (
        words
          .join(' ')
          // Remove spaces after any break tags to ensure when rendered there's no space on the new line
          .replace(/<br> /g, '<br>')
          // Remove any break tags that appear at the end of the string
          .replace(/<br\s*\/?>\s*$/i, '')
      );
    }
    return label;
  });
};
